import { SearchDriver } from "@elastic/search-ui";

export class ElasticService {
  constructor(config, handler) {
    this.driver = new SearchDriver(config);
    this.handler = handler;
    this.permanentFilters = []
  }

  init() {
    const state = this.driver.getState();
    this.driver.subscribeToStateChanges(state => {
      this.handler.onStateChange(state);
    });
    return state;
  }

  search(term) {
    this.driver.getActions().setSearchTerm(term || "");
    this.setPermanentFilters()
  }

  addFilter(facet, value) {
    this.driver.addFilter(facet, value, "any");
  }

  removeFilter(facet, value) {
    this.driver.removeFilter(facet, value, "any");
    this.setPermanentFilters()
  }

  setPageSize(v) {
    this.driver.setResultsPerPage(v);
  }

  setSort(col, order) {
    console.log("setSort", col, order)
    this.driver.setSort(col, order || "asc");
  }

  gotoPage(v) {
    this.driver.setCurrent(v);
  }

  reload() {
    this.gotoPage(1);
  }

  setPermanentFilters(){
    this.permanentFilters.forEach(f => {
      this.driver.addFilter(f.facet, f.filter, "any")
    })
  }



}

//utility extract methods

/*
rawFacet: [
  {
    type, <- may be 'range' 
    value:(JSON|any), 
    data:[
      {
        value:(type==range? {name: <facet name>} :  <facet name>)
      }
    ]
  }
]

stateFilters: [{field:<facet-name>, values:[<facet item key>...]}]
*/
function extractFacet(rawFacet){
  let facet = (rawFacet || [])[0] || { data: [] };
  let isRange = facet.type === "range";
  
  const isJson = !isRange 
  && (facet.data.find(item => (
      item.value != null
      && item.value.constructor === String 
      && (item.value.startsWith("{") || item.value === "null")
    )) != null
  );

  let itens = facet.data.map(item => {
    let obj = isJson? JSON.parse(item.value) : {descricao: isRange? item.value.name: item.value};
    let key = isRange? item.value.name : item.value;

    return {
      key,
      codigo: obj.codigo,
      descricao: obj.descricao,
      count: item.count,
      checked: false,
    };
  });

  return {
    isRange,
    itens 
  }
}


function  extractSentenca(item){
  return {
    titulo: JSON.parse(item.orgaojulgador.raw).descricao,
    dataSentenca: "",
    assunto: JSON.parse(item.assuntos.raw) || {},
    classe: JSON.parse(item.classe.raw) || {},
    competencia: JSON.parse(item.competencia.raw).descricao,
    magistrado: item.pessoas.raw[0],
    sentenca: item.textooriginal.raw,
    id: item.id.raw    
  }
}

export const utils = {
  extractFacet, //{isRange, itens:[{key, codigo, descricao, count, checked}]}
  extractSentenca,
}